var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-head-wrapper',[_c('div',{staticClass:"wrap"},[_c('a-icon',{staticClass:"icon",attrs:{"type":"exclamation-circle"}}),_c('span',{staticClass:"info"},[_vm._v("待开发的页面")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }